import React from 'react';
import ReactDOM from 'react-dom';
import IntegrationReportReact from './IntegrationReport';

class IntegrationReport extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `<div id="root"></div>`;

    ReactDOM.render(React.createElement(IntegrationReportReact), this.querySelector('#root'));
  }
}

customElements.define('integration-report', IntegrationReport);
